export default "__VITE_ASSET__BcI4Pyg2__"